export const isPharmacy = (name: string) => name.includes('薬局');
